/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/applicationList.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { GET_MARRIAGE_CERTIFICATES } from '../../api/graphql';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IGetMarriageExemptionApplicationMethods
  extends IPluginMethodMap {
  getApplications(args: any): Promise<any>;
}

export class GetMarriageExemptionApplicationService implements IAgentPlugin {
  readonly methods: IGetMarriageExemptionApplicationMethods;

  constructor() {
    this.methods = {
      getApplications: this.getApplications.bind(this),
    };
  }

  private async getApplications(args: any) {
    console.log('2nd came');
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_MARRIAGE_CERTIFICATES, {
          input: {
            skip: args?.offset,
            limit: args?.size || 10,
            where: [
              ...(args?.where ?? []),
              {
                column: 'type',
                op: 'Equal',
                value: 'MARRIAGE_EXEMPTION_CERTIFICATE',
              },
            ],
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfCertificate?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            data: _rowData,
            //hi
            isEmpty: _rowData
              ? res?.data?.getListOfCertificate?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfCertificate?.currentPage,
            pageSize: res?.data?.getListOfCertificate?.pageSize,
            totalItems: res?.data?.getListOfCertificate?.totalCount,
            totalCount:
              res?.data?.getListOfCertificate?.totalPages *
              res?.data?.getListOfCertificate?.totalCount,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          id: item?.credentialNo,
          title: item?.credentialNo,
          listImg: 'ME',
          badges: [this.getFormattedStatus(item?.status)],
          // status: item?.status,
          meta: [
            item?.issuedTo?.firstName
              ? `${
                  item?.issuedTo?.lastName
                    ? toHeaderCase(item?.issuedTo?.lastName ?? '')
                    : ''
                } ${toHeaderCase(item?.issuedTo?.firstName)} ${
                  item?.issuedTo?.middleName
                    ? toHeaderCase(item?.issuedTo?.middleName ?? '')
                    : ''
                }`
              : '',
            item?.issuedTo?.email,
            this.formatCreatedDate(item?.validFrom),
            this.formatCreatedDate(item?.validTill),
          ],

          // status: "success",

          status: this.getFormattedStatus(item?.status, item?.validTill),
          // employer: item?.employer?.name,
          validTill: this.formatCreatedDate(item?.validTill),
          validFrom: this.formatCreatedDate(item?.validFrom),
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    console.log('ans->', date);
    if (date) {
      const ans = moment(date).format('LLL');
      console.log('ans->', ans);
      return ans;
    }
  }

  private getFormattedStatus(status: string, date?: any) {
    if (status) {
      switch (status) {
        case 'ACTIVE':
          return { key: 1, title: 'Active', color: '#00AB08' };
        case 'APPLIED_FOR_RENEWAL':
          return { key: 1, title: 'Applied for Renewal', color: '#ffb700' };
        case 'EXPIRING_SOON':
          return { key: 1, title: 'Expiring Soon', color: '#ffb700' };
        case 'EXPIRED':
          return { key: 1, title: 'Expired', color: '#E3040E' };
        case 'TERMINATED':
          return { key: 1, title: 'Terminated', color: '#E3040E' };
        case 'CREDENTIAL_DOES_NOT_EXIST':
          if (moment(date).isBefore(moment()))
            return { key: 1, title: 'Expired', color: '#E3040E' };
          const expiringIn = moment(date).diff(moment(), 'months');
          if (expiringIn <= 3)
            return { key: 1, title: 'Expiring Soon', color: '#ffb700' };
          return { key: 1, title: 'Active', color: '#00AB08' };
        default:
          return '-';
      }
    }
  }
}
